/**
 * Pantalla global de error de carga (API / red caída).
 * Se limpia al cambiar de ruta; se activa desde hooks con reportPageLoadFailure().
 */
import { create } from "zustand";

interface PageLoadErrorState {
  active: boolean;
  show: () => void;
  clear: () => void;
}

export const usePageLoadErrorStore = create<PageLoadErrorState>((set) => ({
  active: false,
  show: () => set({ active: true }),
  clear: () => set({ active: false }),
}));
